import React, { useEffect, useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Chart } from "react-google-charts";
import { Tabs, Tab, ListGroup, Spinner } from 'react-bootstrap'
import { Modal, ModalManager, Effect } from 'react-dynamic-modal';
import moment from 'moment'

import './index.css'
import { GrClose } from 'react-icons/gr'

export default function DeviceModal({ device, deviceData }) {
  const body = document.getElementsByTagName('body')[0];

  const [temperatures, setTemperatures] = useState([]);
  const [humidities, setHumidities] = useState([]);
  const [maxTemperature, setMaxTemperature] = useState()
  const [minTemperature, setMinTemperature] = useState()
  const [maxHumidity, setMaxHumidity] = useState()
  const [minHumidity, setMinHumidity] = useState()
  const [key, setKey] = useState('Temperatura');

  const optionsTemperatura = {
    hAxis: {
      title: 'Horário',
      textPosition: 'none'
    },
    vAxis: {
      title: 'Temperatura (°C)',
      minValue: minTemperature,
    },
    curveType: 'line',
    colors: ['#35A0E6'],
  };

  const optionsUmidade = {
    hAxis: {
      title: 'Horário',
      textPosition: 'none'
    },
    vAxis: {
      title: 'Umidade (%)',
      minValue: minHumidity,
    },
    curveType: "line",
    colors: ['#35A0E6'],
  };

  useEffect(() => {
    if(deviceData){
      getTemperatures(deviceData)
      getHumidities(deviceData)
    }
  },[])

  useEffect(() => {
    setMaxTemperature(indexOfMax(temperatures))
    setMinTemperature(indexOfMin(temperatures))
    setMaxHumidity(indexOfMax(humidities))
    setMinHumidity(indexOfMin(humidities))
  }, [temperatures, humidities])

  const closeModal = () => {
    ModalManager.close()
    body.style.overflow = 'auto'
  }

  const getTemperatures = (data) => {
    let temperaturesArray = []
    data.map((data) => {
      temperaturesArray.push([moment.utc(data.createdAt).local().format('DD/MM HH:mm:ss'), data.temperature])
    })
    temperaturesArray.sort()
    temperaturesArray.unshift(["Horário", "Temperatura"])
    setTemperatures(temperaturesArray)
  }

  const getHumidities = (data) => {
    let humiditiesArray = []
    data.map((data) => {
      humiditiesArray.push([moment.utc(data.createdAt).local().format('DD/MM HH:mm:ss'), data.humidity])
    })
    humiditiesArray.sort()
    humiditiesArray.unshift(["Horário", "Umidade"])
    setHumidities(humiditiesArray)
  }

  const indexOfMax = arr => {
    let newArr = []
    for (let i = 0; i < arr.length; i++) {
      let result = arr[i].filter(function (element) {
        return typeof element !== 'string';
      });
      newArr.push(result)
    }
    var novoArray = newArr.flat(1)
    var max = Math.max(...novoArray)
    return max
  }

  const indexOfMin = arr => {
    let newArr = []
    for (let i = 0; i < arr.length; i++) {
      let result = arr[i].filter(function (element) {
        return typeof element !== 'string';
      });
      newArr.push(result)
    }
    var novoArray = newArr.flat(1)
    var min = Math.min(...novoArray)
    return min
  }

  const style = {
    overlay: {
      position: 'fixed',
      top: '0%',
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
    },

    content: {
      border: '1px solid rgba(0, 0, 0, .2)',
      boxShadow: '0 5px 10px rgba(0, 0, 0, .3)',
      bottom: '15%',
      padding: '1rem'
    }
  }

  return (
    <Modal
      style={style}
      onRequestClose={() => { }}
      effect={Effect.Fall}>
      <div className="DeviceModal">
        <div className="title">
          {device.name}
        </div>
        <div className="actions">
          <GrClose onClick={closeModal} />
        </div>
      </div>
      <Tabs
        id="controlled-tab-device-modal"
        activeKey={key}
        onSelect={(k) => setKey(k)}
      >
        <Tab eventKey="Temperatura" title="Temperatura">
          <div className={"my-pretty-chart-container"}>
            <Chart
              chartType="LineChart"
              loader={<div className="loading-chart"> 
              <Spinner animation="border" />
              </div>}
              width="100%"
              height="400px"
              data={temperatures}
              options={optionsTemperatura}
            />
            <br />
            <Row>
              <Col md={6}>
                <ListGroup as="ul">
                  <ListGroup.Item as="li" variant="danger">
                    Temperatura Máxima Registrada esse
                  </ListGroup.Item>
                  <ListGroup.Item as="li">{maxTemperature} °C</ListGroup.Item>
                </ListGroup>
              </Col>
              <Col md={6}>
                <ListGroup as="ul">
                  <ListGroup.Item as="li" variant="primary">
                    Temperatura Mínima Registrada
                  </ListGroup.Item>
                  <ListGroup.Item as="li">{minTemperature} °C</ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>
          </div>
        </Tab>
        <Tab eventKey="Umidade" title="Umidade">
          <div>
            <Chart
              chartType="LineChart"
              width="100%"
              height="400px"
              data={humidities}
              options={optionsUmidade}
            />
            <br />
            <Row>
              <Col md={6}>
                <ListGroup as="ul">
                  <ListGroup.Item as="li" variant="danger">
                    Umidade Máxima Registrada
                  </ListGroup.Item>
                  <ListGroup.Item as="li">{maxHumidity} %</ListGroup.Item>
                </ListGroup>
              </Col>
              <Col md={6}>
                <ListGroup as="ul">
                  <ListGroup.Item as="li" variant="primary">
                    Umidade Mínima Registrada
                            </ListGroup.Item>
                  <ListGroup.Item as="li">{minHumidity} %</ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>
          </div>
        </Tab>
      </Tabs>
    </Modal>
  );
}